<template>
  <div class="w-full">
    <div
      class="flex items-start pl-10 w-full m-10 cursor-pointer"
      @click="goBack"
    >
      <logo-icon />
    </div>
    <div
      style="min-height: 80vh"
      class="flex flex-col items-center justify-center"
    >
      <error-image />
      <span> oops</span>
      <span class="text-xs text-red-500"> PAGE NOT FOUND </span>
      <div
        @click="goBack"
        class="bg-primary px-12 cursor-pointer text-white text-sm p-2 rounded-lg mt-8"
        to="login"
      >
        Go back Home
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'invalid-page',
  props: {},
  methods: {
    goBack () {
      this.$router.push('dashboard')
    }
  },
  components: {
    ErrorImage: () => import('@/assets/images/ErrorImage.vue'),
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  }
}
</script>
